import React from 'react'
import '../claim-form.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CommonApi from '../../../apis/common'
import CommonUtils from '../../../utility/common-utilities'
import CryptoJS from 'crypto-js'
const transferToData = [
  {
    title: 'My Own',
    value: 'My Own'
  },
  {
    title: 'My Father',
    value: 'My Father'
  },
  {
    title: 'My Mother',
    value: 'My Mother'
  },
  {
    title: 'Others',
    value: 'Others'
  }
]
const eventId = "630c4903ac18965247ec50a3";
class FLCClaimForm extends React.Component {
  state = {
    loading: false,
    homeworkDetails: {
      studentCount: 0
    },
    isSuccess: false,
    showFypCard: false
  }

  countryCodeHash = {}

  constructor (props) {
    super(props)
    this.state.discountId = props.match.params.id
  }

  componentDidMount () {
    this.getDiscountDetails()
  }

  getDiscountDetails = _ => {
    const { discountId } = this.state
    const payload = {
      _id: discountId
    }
    CommonApi.discountDetails(payload)
      .then(data => {
        
        if (data && data.user) {
          this.setState({
            discountDetails: data,
            discountError: false,
            email: data.user?.email || '',
            name: data.user?.name || '',
            city: data.user?.city || '',
            countryCode: data.user?.countryCode || '',
            mobileNumber: data.user?.mobileNumber || '',
            rank : data.user?.rank || ''
          })
        } else {
          this.setState({
            discountError: true
          })
        }
      })
      .catch(err => {
        this.setState({
          discountError: true
        })
      })
  }

  copyLink = _ => {
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)

    dummy.value = 'www.countingwell.com/sccode/33523'
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  getCountryCodes (payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropDownData = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropDownData })
        }
      })
      .catch(err => {})
  }

  buildCountryCodeDropdown (list = []) {
    let countryCodeDropdown = []
    let localHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!localHash[item.dialCode]) {
        this.countryCodeHash[item.dialCode] = item
        localHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          addOn: item.name,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: this.countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch (value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  validatePayload = _ => {
    this.setState({
      isValidForm: false
    })
    let motherCountryCodeDetail = this.state.hashedCountryCode[
      this.state.motherCountryCode
    ]
    let validateMotherCountryCode = CommonUtils.validateMobileNumber(
      this.state.motherPhoneNumber,
      motherCountryCodeDetail
    )
    let fatherCountryCodeDetail = this.state.hashedCountryCode[
      this.state.fatherCountryCode
    ]
    let validateFatherCountryCode = CommonUtils.validateMobileNumber(
      this.state.fatherPhoneNumber,
      fatherCountryCodeDetail
    )
    if (!validateMotherCountryCode) {
      this.setState({ isInvalidMotherMobile: true })
      return false
    } else {
      this.setState({ isInvalidMotherMobile: false })
    }

    if (!validateFatherCountryCode) {
      this.setState({ isInvalidFatherMobile: true })
      return false
    } else {
      this.setState({ isInvalidFatherMobile: false })
    }

    if (!this.state.name) return false

    if (!this.state.email || this.state.isInvalidEmail) return false

    if (!this.state.schoolName) return false

    if (!this.state.address) return false

    if (!this.state.city) return false

    if (!this.state.zipCode) return false

    if (!this.state.mathsTeacherName) return false

    if (!this.state.motherName) return false

    if (!this.state.fatherName) return false

    if (!this.state.motherCountryCode || !this.state.motherCountryCode.trim())
      return false

    if (!this.state.motherPhoneNumber || !this.state.motherPhoneNumber.trim())
      return false

    if (!this.state.fatherCountryCode || !this.state.fatherCountryCode.trim())
      return false

    if (!this.state.fatherPhoneNumber || !this.state.fatherPhoneNumber.trim())
      return false

    // if (!this.state.transerTo) return false

    // if (!this.state.accountName) return false

    // if (!this.state.bankName) return false

    // if (!this.state.bankBranch) return false

    // if (!this.state.bankCity) return false

    // if (!this.state.ifscCode) return false

    // if (!this.state.accountNumber) return false

    if (!this.state.schoolIdImage) return false

    if (!this.state.studentPicture) return false

    return true
  }

  saveClaimDetails = (subType, callback) => {
    this.setState({ isSubmit: true, showError: true })
    // let isValid = this.validatePayload(true)
    // if (!isValid) {
    //   this.setState({
    //     isSubmit: false
    //   })
    //   return false
    // }

    let hashKey = CryptoJS.AES.encrypt(
      Constants.STUDENT_FORM_FILL_SECRET_MESSAGE,
      Constants.STUDENT_FORM_FILL_SECRET_KEY
    ).toString()

    const payload = {
      eventId,
      discountId: this.state.discountId,
      email: this.state.email,
      name: this.state.name,
      city: this.state.city,
      countryCode: this.state.countryCode,
      mobileNumber: this.state.mobileNumber,
      subType,
      hashKey
    }

    CommonApi.addClaimDetails(payload)
      .then(data => {
        this.setState({
          isSubmit: false,
          isSuccess: true
        }, _ => {
          callback()
        })
      })
      .catch(err => {
        this.setState({
          isSubmit: false
        })
      })
  }

  onChangeHandler = (event, key) => {
    this.setState({ [key]: event.target.value }, _ => {
      if (key === 'email') {
        this.setState({
          isSubmit: false
        })
      }
      this.validatePayload()
    })
  }

  onImageUpload (event, key) {
    this.setState({ hideDone: true })
    let file = event.target.files[0]
    if (!file) return
    let previewImage = URL.createObjectURL(file)
    this.setState({
      [key + 'Preview']: previewImage
    })
    this.getSignedURL(file, key)
  }

  getSignedURL (file, key) {
    let payload = {
      fileName: file.name
    }
    CommonApi.getSignedUrl(payload)
      .then(response => {
        this.uploadFile(response.data.signedUrl, file, key)
      })
      .catch(error => {
        console.log(error)
      })
  }

  uploadFile = (signedUrl, file, key) => {
    let type = 'IMAGE'
    if (file.type.includes('video')) type = 'VIDEO'
    else if (file.type.includes('audio')) type = 'AUDIO'

    CommonApi.uploadFileAwsS3(signedUrl, file)
      .then(response => {
        let splittedSignedUrl = signedUrl.split('?')
        if (splittedSignedUrl && splittedSignedUrl.length) {
          this.setState({ [key]: splittedSignedUrl[0], uploadedFileType: type })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  onSelect = (option, key) => {
    this.setState({ [key]: option?.value }, _ => {
      this.validatePayload()
      if (key === 'city' && option?.value) {
        let cityInfo = this.cityHash[option?.value]
        if (cityInfo.countryCode) {
          this.setState(
            {
              countryCode: cityInfo.countryCode
            },
            _ => {
              if (this.countryCodeDropdownRef) {
                this.countryCodeDropdownRef.clearAll()
                if (
                  this.props.hashedCountryCode &&
                  this.props.hashedCountryCode[cityInfo.countryCode]
                ) {
                  const countryCodeData = this.props.hashedCountryCode[
                    cityInfo.countryCode
                  ]
                  this.countryCodeDropdownRef.onClickOption({
                    title: `${countryCodeData.name} ${countryCodeData.dialCode}`,
                    addOn: countryCodeData.name,
                    value: countryCodeData.dialCode
                  })
                }
              }
            }
          )
        } else {
          this.setState({ countryCode: '', reloadCountryCode: true }, () => {
            this.setState({ reloadCountryCode: false })
          })
        }
      }
    })
  }

  onSelectTransferTo = option => {
    this.setState({ transerTo: option?.value })
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  render () {
    const {
      toasterMessage,
      toasterType,
      showToaster,
      showFypCard,
      loading,
      countryCode,
      mobileNumber,
      rank
    } = this.state

    return (
      <>
      <div className='claim-form'>
        <div className='container'>
          {/* {this.state.loading && <Loading />} */}
          <div className='row no-gutters'>
            <div
              className={`${
                !showFypCard ? 'col-12' : 'col-6'
              } p-2 py-3 ${!showFypCard && 'text-center'} cw-logo`}
            >
              <img alt='cw-logo' src={getImageSource(ImageConstants.CW_LOGO)} />
            </div>
            {showFypCard && (
              <div className={`col-6 p-2 py-3 fyp-logo text-right`}>
                <img
                  alt='fyp-logo'
                  src='https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/e0e30488-0f32-4f15-8ad0-1366e758ab0c_FLC%20logo.png'
                />
              </div>
            )}
          </div>
          {!showFypCard && !loading && (
            <div className='mt-2'>
              <div className='scholarship-header'>
                Congratulations on Winning the Countingwell - Fyp Financial
                Literacy Challenge.
              </div>
              {countryCode !== "+91" ? <div>
              <div className='scholarship-description pt-3'>
                <p>
                  You have won a discount of 40% on the Countingwell
                  Foundations of Financial Literacy course. We are sure you have
                  experienced the importance and value of bring financially
                  prepared from a young age.
                </p>
                <p>
                  To take up the course and subscribe with a discount, when you
                  subscribe, use the following discount code:
                </p>
              </div>
              </div>
              :  rank >= 26 ? <div>
              <div className='scholarship-description pt-3'>
                <p>
                  You have won a discount of 40% on the Countingwell
                  Foundations of Financial Literacy course. We are sure you have
                  experienced the importance and value of bring financially
                  prepared from a young age.
                </p>
                <p>
                  To take up the course and subscribe with a discount, when you
                  subscribe, use the following discount code:
                </p>
              </div>
              </div> : <div>
              <div className='scholarship-description pt-2'>
                <div>You have won:</div>{' '}
                <ol>
                  <li>A Fyp Card</li>
                  <li>
                    A Discount of 40% on the Countingwell Foundations of
                    Financial Literacy Course
                  </li>
                </ol>
              </div>
              <div className='scholarship-description pt-2'>
                <p>
                  This card is issued by Fyp and should you have any further
                  questions or issue related to the issuance of the card, please
                  contact Fyp directly at &lt;
                  <a href='mailto:support@fypmoney.in'>support@fypmoney.in</a>
                  &gt;
                </p>
                <div className='text-center'>
                  <button
                    className={`cw-button-primary`}
                    onClick={_ => {
                      this.setState({
                        showFypCard: !this.state.showFypCard
                      })
                    }}
                  >
                    CLAIM FYP CARD
                  </button>
                </div>
              </div>
              <div className='scholarship-description pt-3'>
                <p>
                  You have also won a discount of 40% on the Countingwell
                  Foundations of Financial Literacy course. We are sure you have
                  experienced the importance and value of bring financially
                  prepared from a young age.
                </p>
                <p>
                  To take up the course and subscribe with a discount, when you
                  subscribe, use the following discount code:
                </p>
              </div>
              </div> }
             
              
              {/* <div className='scholarship-description pt-2'>
                <p>
                  This card is issued by Fyp and should you have any further
                  questions or issue related to the issuance of the card, please
                  contact Fyp directly at &lt;
                  <a href='mailto:support@fypmoney.in'>support@fypmoney.in</a>
                  &gt;
                </p>
                <div className='text-center'>
                  <button
                    className={`cw-button-primary`}
                    onClick={_ => {
                      this.setState({
                        showFypCard: !this.state.showFypCard
                      })
                    }}
                  >
                    CLAIM FYP CARD
                  </button>
                </div>
              </div>
              <div className='scholarship-description pt-3'>
                <p>
                  You have also won a discount of 40% on the Countingwell
                  Foundations of Financial Literacy course. We are sure you have
                  experienced the importance and value of bring financially
                  prepared from a young age.
                </p>
                <p>
                  To take up the course and subscribe with a discount, when you
                  subscribe, use the following discount code:
                </p>
              </div> */}
              <div className='scholarship-header text-center'>FLCGIFT</div>
              <div className='text-center pt-3'>
                <button
                  className={`cw-button-primary`}
                  onClick={_ => {
                    window.open("https://countingwell.com/signup?course=626f973207b51efe258889cc", "_blank");
                    this.saveClaimDetails("SUBSCRIBE_TO_COURSE", _ => {
                      // windowLocation.location;
                    })
                  }}
                >
                  Subscribe to course with my discount
                </button>
              </div>
            </div>
          )}
          {showFypCard && !loading && (
            <div className='mt-2 scholarship-form'>
              {/* <div className='scholarship-header text-center'>Thank you</div> */}
              <div className='scholarship-description text-center pt-5 mt-5'>
                Please create an account on the Fyp App with same mobile number
                as you registered on Countingwell, to enable Fyp to activate
                your card. You will have to provide your address to Fyp in order
                to enable them to deliver the card.
              </div>
              <div className='scholarship-header text-center pt-2'>
                Your Mobile No: {countryCode + ' ' + mobileNumber}
              </div>
              <div className='text-center pt-4'>
                <button
                className={`cw-button-primary`}
                onClick={_ => {
                  window.open("https://www.fypmoney.in/app", "_blank");
                  this.saveClaimDetails("CLAIM_FYP_CARD", _ => {
                    // windowLocation.location = "";
                  })
                }}>
                  Open Fyp
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
        {showToaster ? (
          <ToasterComponent
            message={toasterMessage}
            type={toasterType}
            position='bottom-center'
          />
        ) : (
          ''
        )}
      </>
    )
  }
}

export default FLCClaimForm
